import { Component, Inject } from '@angular/core';
import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { IFile } from '../../interfaces/referral.interface';
import { MatChipEditedEvent, MatChipInputEvent, MatChipGrid, MatChipRow, MatChipRemove, MatChipInput } from '@angular/material/chips';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { AssetUrlPipe } from '../../pipes/asset-url.pipe';

@Component({
    selector: 'app-edit-file-dialog',
    templateUrl: './edit-file-dialog.component.html',
    styleUrl: './edit-file-dialog.component.scss',
    imports: [FormsModule, ReactiveFormsModule, CdkScrollable, MatDialogContent, MatFormField, MatChipGrid, MatChipRow, MatChipRemove, MatIcon, MatChipInput, MatInput, MatButton, MatSuffix, MatMenuTrigger, MatMenu, MatMenuItem, MatDialogActions, AssetUrlPipe]
})
export class EditFileDialogComponent {
  readonly addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA, SPACE] as const;
  inputForm!: FormGroup;
  fileElement: IFile;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<EditFileDialogComponent>
  ) {

    this.fileElement = Object.assign({}, this.data.element);
    let properties = JSON.parse(this.fileElement.properties);
    this.inputForm = this.formBuilder.group({
      description: new FormControl(properties.Description),
      tags: new FormControl(this.fileElement.tags ? this.fileElement.tags?.split(',') : []),
      file: new FormControl(null),
      fileByteArray: new FormControl(null),
      fileName: new FormControl(this.fileElement.name)
    });
  }

  onUpdate() {
    if (this.inputForm.invalid) {
      this.inputForm.markAllAsTouched();
      return;
    }
    this.dialogRef.close(this.inputForm.value);
  }

  close() {
    this.dialogRef.close(false);
  }

  addTag(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {

      let tags = this.inputForm.controls['tags'].value;
      if (!tags?.length) {
        tags = [];
      }
      tags.push(value);
      this.inputForm.controls['tags'].setValue(tags);

    }
    event.chipInput!.clear();
  }

  removeTag(tag: string): void {
    let tags = this.inputForm.controls['tags'].value;
    if (tags?.length) {
      const tagIndex = tags.indexOf(tag);
      if (tagIndex > -1) {
        tags?.splice(tagIndex, 1);
        this.inputForm.controls['tags'].setValue(tags);
      }
    }
  }

  editTag(tag: string, event: MatChipEditedEvent) {
    const value = event.value.trim();
    let tags = this.inputForm.controls['tags'].value;
    if (tags?.length) {
      if (!value) {
        this.removeTag(tag);
        return;
      }

      const tagIndex = tags?.indexOf(tag) || -1;
      if (tagIndex > -1) {
        tags[tagIndex] = value;

        this.inputForm.controls['tags'].setValue(tags);
        return [...tags];
      }
    }

    return tags;
  }

  onFileSelected(e: any) {
    if (e.target.files.length) {
      this.inputForm.patchValue({ file: e.target.files[0] });
      this.fileElement.name = e.target.files[0].name;
      this.inputForm.patchValue({
        fileName: this.fileElement.name
      });
      if (typeof (FileReader) !== 'undefined') {
        const reader = new FileReader();

        reader.onload = (e: any) => {
          this.inputForm.patchValue({ fileByteArray: e.target.result });
        };

        reader.readAsArrayBuffer(e.target.files[0]);
      }
    }
  }
}
